import {Component} from '@angular/core';
import {ModalKendo} from '../../lib/ModalKendo';
import {EstoqueService} from '../../services/estoque.service';

@Component({
  selector: 'app-modal-gerar-produtos',
  templateUrl: './modal-gerar-produtos.component.html',
  styleUrls: ['./modal-gerar-produtos.component.scss']
})
export class ModalGerarProdutosComponent extends ModalKendo {
  grupos: any[] = [];
  insumos: any[] = [];
  grupoSelecionado: any;
  categoria = '';
  linhas: any[] = [];
  idsSelecionados: number[] = [];
  gerando = false;
  gerouAlgum = false;

  constructor(private estoqueService: EstoqueService) {
    super();
  }

  configure(grupos: any[], insumos: any[]): void {
    this.grupos = grupos || [];
    this.insumos = (insumos || []).filter((insumo: any) =>
      !insumo.removido && (
        insumo.objeto === 'insumo' ||
        insumo.objeto === 'ficha-tecnica' && insumo.tipo === 'produto-venda'
      )
    );
    if(this.grupos.length){
      this.grupoSelecionado = this.grupos[0];
      this.selecionouGrupo(this.grupoSelecionado);
    }
  }

  selecionouGrupo(grupo: any): void {
    this.grupoSelecionado = grupo;
    this.categoria = grupo && grupo.nome ? grupo.nome : '';
    this.linhas = grupo ? this.insumos
      .filter((insumo: any) => Number(insumo.grupo && insumo.grupo.id) === Number(grupo.id))
      .map((insumo: any) => ({
        idInsumo: Number(insumo.id),
        insumo,
        nome: insumo.nome,
        codigoPdv: insumo.codigo == null ? '' : String(insumo.codigo),
        totalVinculosProdutos: Array.isArray(insumo.produtos) ? insumo.produtos.length : 0,
        preco: null,
        status: null,
        erro: null,
        produto: null
      })) : [];
    this.idsSelecionados = this.linhas.map((linha: any) => linha.idInsumo);
  }

  todasLinhasSelecionadas(): boolean {
    const pendentes = this.linhas.filter((linha: any) => linha.status !== 'sucesso');
    return !!pendentes.length && pendentes.every((linha: any) =>
      this.idsSelecionados.includes(linha.idInsumo)
    );
  }

  selecaoParcial(): boolean {
    return !!this.idsSelecionados.length && !this.todasLinhasSelecionadas();
  }

  quantidadeSelecionada(): number {
    return this.linhas.filter((linha: any) =>
      this.idsSelecionados.includes(linha.idInsumo)
    ).length;
  }

  quantidadePendente(): number {
    return this.linhas.filter((linha: any) =>
      this.idsSelecionados.includes(linha.idInsumo) &&
      linha.status !== 'sucesso' && !this.linhaPronta(linha)
    ).length;
  }

  quantidadePronta(): number {
    return this.linhas.filter((linha: any) =>
      this.idsSelecionados.includes(linha.idInsumo) &&
      linha.status !== 'sucesso' && this.linhaPronta(linha)
    ).length;
  }

  linhaPronta(linha: any): boolean {
    return !!String(linha.nome || '').trim() &&
      linha.preco !== null && linha.preco !== undefined && linha.preco !== '' &&
      Number.isFinite(Number(linha.preco)) && Number(linha.preco) >= 0;
  }

  altereSelecaoTodasLinhas(evento: Event): void {
    const selecionado = (evento.target as HTMLInputElement).checked;
    this.idsSelecionados = selecionado
      ? this.linhas.filter((linha: any) => linha.status !== 'sucesso')
        .map((linha: any) => linha.idInsumo)
      : [];
  }

  podeGerar(): boolean {
    return !this.gerando && !!this.categoria.trim() && this.linhas.some((linha: any) =>
      this.idsSelecionados.includes(linha.idInsumo) && linha.status !== 'sucesso'
    );
  }

  async gereProdutos(): Promise<void> {
    if(!this.podeGerar())
      return;

    this.gerando = true;
    const selecionadas = this.linhas.filter((linha: any) =>
      this.idsSelecionados.includes(linha.idInsumo) && linha.status !== 'sucesso'
    );

    for(const linha of selecionadas){
      linha.status = 'processando';
      linha.erro = null;
      try {
        this.valideLinha(linha);
        linha.produto = await this.estoqueService.gereProdutoDeInsumo(linha.idInsumo, {
          nome: linha.nome,
          codigoPdv: linha.codigoPdv,
          preco: linha.preco,
          categoria: this.categoria
        });
        linha.status = 'sucesso';
        linha.totalVinculosProdutos++;
        this.gerouAlgum = true;
        this.idsSelecionados = this.idsSelecionados.filter(id => id !== linha.idInsumo);
      } catch(erro) {
        linha.status = 'erro';
        linha.erro = this.textoErro(erro);
      }
    }
    this.gerando = false;
  }

  feche(): void {
    if(!this.gerando)
      this.fecheModal({gerou: this.gerouAlgum});
  }

  private valideLinha(linha: any): void {
    if(!String(linha.nome || '').trim())
      throw new Error('Informe o nome do produto.');
    if(linha.preco === null || linha.preco === undefined || linha.preco === '' ||
       !Number.isFinite(Number(linha.preco)) || Number(linha.preco) < 0)
      throw new Error('Informe um preço válido.');
  }

  private textoErro(erro: any): string {
    if(typeof erro === 'string')
      return erro;
    return erro && (erro.erro || erro.message) || 'Não foi possível gerar o produto.';
  }
}
